module.exports = __webpack_public_path__ + "assets/img/check_radio_sheet.png";